import { addressGoogle } from './addressGoogle';
import { attachments } from './attachments';
import { basicInfo } from './basicInfo';
import { birthYear } from './birthYear';
import { companyEmployees } from './companyEmployees';
import { companyName } from './companyName';
import { date } from './date';
import { email } from './email';
import { emergencyDisclaimer } from './emergencyDisclaimer';
import { evaluationInfo } from './evaluationInfo';
import { firstName } from './firstName';
import { forCompaniesPrivacyPolicyAgreement } from './forCompaniesPrivacyPolicyAgreement';
import { forCompaniesTermsConditionsAgreement } from './forCompaniesTermsConditionsAgreement';
import { fullName } from './fullName';
import { hrbAgreements } from './hrbAgreements';
import { hrbOrderQuestionText } from './hrbOrderQuestionText';
import { ico } from './ico';
import { insuranceCompany } from './insuranceCompany';
import { languageSelector } from './languageSelector';
import { lastName } from './lastName';
import { msCenter } from './msCenter';
import { phone } from './phone';
import { preventionInfo } from './preventionInfo';
import { rsAssistantAgreements } from './rsAssistantAgreements';
import { sex } from './sex';
import { time } from './time';
import { updatePassword } from './updatePassword';
import { zipCode } from './zipCode';
import { medicalCategories } from './medicalCategories';

export const forms = {
  namespaced: true,
  modules: {
    addressGoogle,
    attachments,
    basicInfo,
    birthYear,
    companyEmployees,
    companyName,
    date,
    email,
    emergencyDisclaimer,
    evaluationInfo,
    firstName,
    forCompaniesPrivacyPolicyAgreement,
    forCompaniesTermsConditionsAgreement,
    fullName,
    hrbAgreements,
    hrbOrderQuestionText,
    ico,
    insuranceCompany,
    languageSelector,
    lastName,
    msCenter,
    phone,
    preventionInfo,
    rsAssistantAgreements,
    sex,
    time,
    updatePassword,
    zipCode,
    medicalCategories
  }
};
